import { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import PortalLayout from '../../layouts/PortalLayout';
import { SidebarUser, SidebarLabel, SidebarNavItem } from '../../layouts/SidebarNav';
import { PortalCard, StatsRow, DataTable } from './_portal.css';
import StatusBadge from '../../components/common/StatusBadge';

const MENU = [
  { id: 'overview', icon: '📊', label: 'Overview' },
  { id: 'complaints', icon: '🛡️', label: 'Complaints', badge: 18 },
  { id: 'audits', icon: '🔍', label: 'Audits' },
  { id: 'incidents', icon: '⚠️', label: 'Incidents', badge: 3 },
  { id: 'analytics', icon: '📈', label: 'Analytics' },
  { id: 'nabl', icon: '🏆', label: 'NABL Compliance' },
  { id: 'reports', icon: '📄', label: 'Reports' },
];

const QAPortal = () => {
  const [active, setActive] = useState('overview');

  return (
    <PortalLayout
      brand="TrustLab"
      brandSub="QA Portal"
      accent="#EF4444"
      topbarTitle="QUALITY ASSURANCE"
      topbarRight={
        <Stack direction="row" spacing={1}>
          <Button variant="outlined" size="small" sx={{ display: { xs: 'none', sm: 'inline-flex' } }}>
            Export
          </Button>
          <Button variant="contained" color="primary" size="small">
            + Incident
          </Button>
        </Stack>
      }
      sidebar={
        <>
          <SidebarUser initials="NK" name="Dr. Nalini Kumar" role="Head of QA" avatarColor="#EF4444" />
          <SidebarLabel>QA Tools</SidebarLabel>
          {MENU.map((m) => (
            <SidebarNavItem key={m.id} {...m} active={active === m.id} onClick={() => setActive(m.id)} />
          ))}
        </>
      }
    >
      <StatsRow
        items={[
          { label: 'Open Complaints', value: 18, sub: '5 urgent · SLA 2h', accent: '#EF4444' },
          { label: 'Resolution Rate', value: '96%', sub: 'Target: 95%', accent: '#00B49A' },
          { label: 'Avg Resolution', value: '14h', sub: '-3h MoM', accent: '#F0B429' },
          { label: 'NABL Score', value: '9.8/10', sub: 'ISO 15189:2022', accent: '#6366F1' },
        ]}
      />

      <Grid container spacing={2.5}>
        <Grid item xs={12} md={8}>
          <PortalCard title="Complaint Queue">
            <DataTable
              columns={['Ticket', 'Category', 'Reporter', 'Age', 'Status']}
              rows={[
                ['TL-71204', 'Report Discrepancy', 'S. Varma', '2h', '🚨 Urgent'],
                ['TL-71203', 'Trustian late', 'P. Kaur', '4h', '⏳ Open'],
                ['TL-71202', 'Billing query', 'R. Sharma', '1d', '✓ Resolved'],
                ['TL-71201', 'App issue', 'A. Mehta', '1d', '⏳ Open'],
                ['TL-71200', 'Sample re-collection', 'N. Patel', '2d', '✓ Resolved'],
              ]}
            />
          </PortalCard>
        </Grid>
        <Grid item xs={12} md={4}>
          <PortalCard title="Active Incidents">
            <Stack spacing={1.75}>
              {[
                ['Centrifuge maint · NRL Begumpet', 'Scheduled', 'amber'],
                ['Reagent batch recall · Vitamin B12', 'Action req', 'red'],
                ['Temp excursion · Mumbai cold chain', 'Under review', 'amber'],
              ].map(([t, st, tone]) => (
                <Box
                  key={t}
                  sx={{ p: 2, bgcolor: '#F4F6F8', borderRadius: '6px', border: '1px solid #EDF1F4' }}
                >
                  <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#10151C', mb: 0.5 }}>{t}</Typography>
                  <StatusBadge tone={tone}>{st}</StatusBadge>
                </Box>
              ))}
            </Stack>
          </PortalCard>
        </Grid>
        <Grid item xs={12}>
          <PortalCard title="Resolution SLA — Last 30 days">
            <Stack direction="row" spacing={0.75} alignItems="flex-end" sx={{ height: 100 }}>
              {[82, 90, 88, 95, 92, 88, 94, 96, 98, 93, 96, 98].map((v, i) => (
                <Box
                  key={i}
                  sx={{
                    flex: 1,
                    height: `${v}%`,
                    bgcolor: v >= 95 ? '#00B49A' : v >= 90 ? '#F0B429' : '#EF4444',
                    borderRadius: '4px 4px 0 0',
                  }}
                  title={`${v}%`}
                />
              ))}
            </Stack>
          </PortalCard>
        </Grid>
      </Grid>
    </PortalLayout>
  );
};

export default QAPortal;
